import { useContext } from 'react';

import { OffersContext, IOffersContext } from 'productTemplate/providers/OffersProvider';

export const useOffersContext = () => useContext<IOffersContext>(OffersContext);
